const REPOSITORY_PATH = /^\/repositories\/[a-z0-9]+(?:-[a-z0-9]+)*$/

// Only follow paths this app actually serves for a tracked link.
// Rejects protocol-relative URLs such as //evil.example, which the browser would treat as another site.
export function safeReferralDestination(path) {
  if (path === '/' || (typeof path === 'string' && REPOSITORY_PATH.test(path))) {
    return path
  }
  return '/'
}
